import { TitleSmall } from 'v3/shared/typography/TitleSmall';
import { Container } from './styles';

const Footer = () => {
  return (
    <Container>
      <TitleSmall> &copy; 2024 Motorola Mobility LLC. Todos os direitos reservados.</TitleSmall>
    </Container>
  );
};

export default Footer;
